import { SearchContactLensCond } from './types'

export const columnNameToIndexMap: { [k: string]: number } = {
  simpleProductName: 1,
  colorName: 2,
  price: 5,
  fkuUrl: 6,
  imageUrl: 7,
  lensUrl: 8,
  period: 10,
  dia: 11,
  coloringdia: 12,
  bc: 13,
  corrective: 14,
  color: 15,
  border: 16,
  option: 18,
  colorOption: 18,
  spDrawing: 19,
  movieUrl: 22,
  liquidRate: 25,
  hardness: 26,
}

const allowMultipleSelectionColumnNames = [
  'period',
  'color',
  'coloringdia',
  'bc',
  'dia',
  'corrective',
  'option',
]

// OR複数選択項目
const orMultiSelectColumnNames = [
  'period',
  'color',
  'coloringdia',
  'bc',
  'dia',
]

export function isMultipleSelectionAllowedColumnName(columnName: string): boolean {
  return allowMultipleSelectionColumnNames.includes(columnName)
}

export function isMultipleSelectionAllowedColumnIndex(index: number): boolean {
  return allowMultipleSelectionColumnNames.some(
    name => columnNameToIndexMap[name] === index
  )
}

export function isOrColumnIndex(index: number): boolean {
  return orMultiSelectColumnNames.some(name => columnNameToIndexMap[name] === index)
}

// 生データから, UI表示用のデータへ変換.
export function formatRow(row: string[]): string[] {
  for (let i = 0; i < row.length; i += 1) {
    row[i] = row[i].trim()
    if (i === columnNameToIndexMap['period']) {
      if (row[i] === '') {
        row[i] = '非公開'
      }
    } else if (i === columnNameToIndexMap['bc']) {
      if (row[i] === '') {
        row[i] = '非公開'
      }
    } else if (i === columnNameToIndexMap['dia']) {
      if (row[i] === '') {
        row[i] = '非公開'
      }
    } else if (i === columnNameToIndexMap['coloringdia']) {
      if (row[i] === '') {
        row[i] = '非公開'
      }
    }
  }

  return row
}

// 検索.
export function *searchIterator(csvData: string[][], cond: SearchContactLensCond): IterableIterator<string[]> {
  if (csvData) {
    const spDrawingIndex = columnNameToIndexMap['spDrawing']

    for (const item of csvData) {
      // 先頭のカラム(商品名)が空白だった場合、もしくは「CSVData[i][0] == ''」だった場合は次の行に進む
      if (item[0] === '' || item[0] === '商品名') {
        continue
      }

      // スマホ着画必須かどうか?
      if (cond.hasSPDrawing) {
        if (item[spDrawingIndex] === '' || item[spDrawingIndex] === '0') {
          // 着画データがないので
          continue
        }
      }

      let failed = false

      for (const mv of cond.matchValues) {
        let matched: boolean

        if (isOrColumnIndex(mv.columnIndex)) {
          // OR複数選択: グループ内いずれかに合致すること
          matched = mv.columnValues.some(v => !!item[mv.columnIndex].match(v))
        } else {
          // AND複数選択: 全値に合致すること
          matched = mv.columnValues.every((v) => {
            if (!!item[mv.columnIndex].match(v)) return true

            // 高度数が8の場合, 10も検索対象にする.
            if (mv.columnIndex === columnNameToIndexMap['hardness']) {
              if (v === '8' && item[mv.columnIndex] === '10') return true
            }

            // 含水率（高含水・低含水）を数値解釈する.
            if (mv.columnIndex === columnNameToIndexMap['liquidRate']) {
              const liquidRateOfItem = parseFloat(item[mv.columnIndex].replace('%', ''))
              const threshold = 50
              if (!isNaN(liquidRateOfItem)) {
                if (v === '高含水' && liquidRateOfItem >= threshold) return true
                if (v === '低含水' && liquidRateOfItem < threshold) return true
              }
            }

            return false
          })
        }

        if (!matched) {
          failed = true
          break
        }
      }

      if (failed) {
        continue
      }

      // 成功したら返す.
      yield item
    }
  }
}

export function search(csvData: string[][], cond: SearchContactLensCond): string[][] {
  const itemIterator = searchIterator(csvData, cond)
  const items: string[][] = []
  while (true) {
    const item = itemIterator.next()
    if (item.done) {
      break
    }

    if (item.value) {
      items.push(formatRow(item.value))
    }
  }

  return items
}

export function addCond(
  cond: SearchContactLensCond,
  key: number,
  value: string
): void {
  const existing = cond.matchValues.find(mv => mv.columnIndex === key)
  if (existing) {
    if (!isMultipleSelectionAllowedColumnIndex(key)) {
      // 単一選択: 上書き
      existing.columnValues = [value]
    } else if (!existing.columnValues.includes(value)) {
      // 複数選択: 追加
      existing.columnValues.push(value)
    }
  } else {
    cond.matchValues.push({ columnIndex: key, columnValues: [value] })
  }
}

export function removeCond(
  cond: SearchContactLensCond,
  key: number,
  value: string
): void {
  const existing = cond.matchValues.find(mv => mv.columnIndex === key)
  if (!existing) return

  if (isMultipleSelectionAllowedColumnIndex(key)) {
    // 複数選択: 該当 columnValues のみ削除し、空になったら matchValues ごと削除
    existing.columnValues = existing.columnValues.filter(v => v !== value)
    if (existing.columnValues.length === 0) {
      cond.matchValues = cond.matchValues.filter(mv => mv.columnIndex !== key)
    }
  } else {
    // 単一選択: matchValues ごと削除
    cond.matchValues = cond.matchValues.filter(mv => mv.columnIndex !== key)
  }
}
